import { createAsyncThunk } from '@reduxjs/toolkit';

import type { MockEligibleTenant } from '../lib/mockData';
import type {
  ConverterTrialFormData,
  EncerrarTrialFormData,
  EstenderTrialFormData,
  IniciarTrialFormData,
  TrialTenant,
} from '../types';
import { trialsService } from './services';

export const fetchTrials = createAsyncThunk<TrialTenant[]>(
  'trials/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      return await trialsService.fetchAll();
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const fetchTrialsByTenant = createAsyncThunk<TrialTenant[], string>(
  'trials/fetchByTenant',
  async (tenantId, { rejectWithValue }) => {
    try {
      return await trialsService.fetchByTenantId(tenantId);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const fetchEligibleTenants = createAsyncThunk<
  MockEligibleTenant[],
  { search?: string; limit?: number } | undefined
>('trials/fetchEligibleTenants', async (params, { rejectWithValue }) => {
  try {
    return await trialsService.fetchEligibleTenants(params);
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});

export const iniciarTrial = createAsyncThunk<TrialTenant, IniciarTrialFormData>(
  'trials/iniciar',
  async (data, { rejectWithValue }) => {
    try {
      return await trialsService.iniciarTrial(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const estenderTrial = createAsyncThunk<TrialTenant, EstenderTrialFormData>(
  'trials/estender',
  async (data, { rejectWithValue }) => {
    try {
      return await trialsService.estenderTrial(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const converterTrial = createAsyncThunk<TrialTenant, ConverterTrialFormData>(
  'trials/converter',
  async (data, { rejectWithValue }) => {
    try {
      return await trialsService.converterTrial(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const encerrarTrial = createAsyncThunk<TrialTenant, EncerrarTrialFormData>(
  'trials/encerrar',
  async (data, { rejectWithValue }) => {
    try {
      return await trialsService.encerrarTrial(data);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);
